// InsightCard — KPI variant of an Insight tile.
// Pure presentational; no business logic. Consumed by InsightRenderer
// when ``display.type === 'kpi'``. All formatting decisions come from
// the backend's display config — the card just paints what it's told.
import React from 'react';
import * as Icons from 'lucide-react';
import { formatInsightValue } from './format';

export function InsightCard({ insight, loading, error, isAr }) {
  const { title, description, display } = insight || {};
  const row = insight?.rows?.[0] || {};
  const value = row[display?.value_key];
  const subtitleValue = display?.subtitle_key ? row[display.subtitle_key] : null;
  const subtitleLabel = isAr
    ? (display?.subtitle_label || '')
    : (display?.subtitle_label_en || display?.subtitle_label || '');
  const Icon = (display?.icon && Icons[display.icon]) || Icons.Sparkles;

  return (
    <div
      data-testid={`insight-kpi-${insight?.key || 'unknown'}`}
      className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md hover:border-slate-300 transition-all"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="space-y-1">
          <div className="text-sm font-semibold text-slate-700">{title}</div>
          {description && (
            <div className="text-xs text-slate-400 leading-relaxed">{description}</div>
          )}
        </div>
        {Icon && (
          <div className="p-2 rounded-lg bg-gradient-to-br from-indigo-50 to-purple-50 text-indigo-600">
            <Icon size={18} />
          </div>
        )}
      </div>

      {error ? (
        <div className="text-sm text-rose-600" data-testid="insight-error">
          {isAr ? 'تعذّر تحميل البيانات' : 'Unable to load data'}
        </div>
      ) : loading ? (
        <div className="h-9 w-32 rounded bg-slate-100 animate-pulse" />
      ) : (
        <>
          <div
            className="text-3xl font-bold text-slate-900 tracking-tight"
            data-testid="insight-kpi-value"
          >
            {value === undefined || value === null
              ? '—'
              : formatInsightValue(value, display?.value_format)}
          </div>
          {subtitleValue !== null && subtitleValue !== undefined && (
            <div className="mt-1 text-xs text-slate-500">
              {formatInsightValue(subtitleValue, 'number')}{' '}
              {subtitleLabel}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default InsightCard;
